import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.75em;
  margin-left: 0.75em;
  margin-right: 0.75em;

  svg {
    color: ${props => props.theme.table.headerColor};
  }
`;

const CarouselControls = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.2em;
  margin-bottom: 0.2em;

  & > * {
    flex: 0 1 auto;
  }

  .fa-circle {
    font-size: 0.8em;
    margin-left: 0.5em;
    margin-right: 0.5em;

    &[data-prefix='far'] {
      color: #aaa;
    }

    &[data-prefix='fas'] {
      color: ${props => props.theme.h5.color};
    }
  }
`;

export function WcCarouselControls({ items, activeIndex, previous, next }) {
  return (
    <CarouselControls>
      <IconButton onClick={previous}>
        <FontAwesomeIcon
          icon="chevron-circle-left"
          aria-label="Previous item"
        />
      </IconButton>
      {items.map((item, i) => (
        <FontAwesomeIcon
          icon={[i === activeIndex ? 'fas' : 'far', 'circle']}
          key={item.alt}
          aria-label={item.alt}
          aria-current={i === activeIndex}
        />
      ))}
      <IconButton onClick={next}>
        <FontAwesomeIcon icon="chevron-circle-right" aria-label="Next item" />
      </IconButton>
    </CarouselControls>
  );
}

export default WcCarouselControls;
